import { useState } from 'react';
import { Modal, Label, Icon } from 'semantic-ui-react';
import useDownloadFileForPreview from '../../../../behavior/filesUpload/hooks/useDownloadFileForPreview';
import useDownloadFile from '../../../../behavior/filesUpload/hooks/useDownloadFile';
import CustomPDFViewer from './CustomPDFViewer/CustomPDFViewer';

import styles from './CustomPDFViewer/CustomPDFViewer.module.scss';
import { Popup } from 'semantic-ui-react';

type Props = {
  fileName: string;
  uploadId: number;
};

function DownloadableFile({ fileName, uploadId }: Props) {
  const { file, downloadFileForPreview } = useDownloadFileForPreview(uploadId, { enabled: false });
  const { downloadFile } = useDownloadFile(uploadId, { enabled: false });
  const [open, setOpen] = useState(false);

  const renderDocument = (file: any) => {
    const url = URL.createObjectURL(file.data);

    return (
      <div>
        <Modal closeIcon open={open} onClose={() => setOpen(false)} className={styles.modal}>
          <Modal.Header>{fileName}</Modal.Header>
          <div className={`rpv-core__viewer ${styles.modalContent}`}>
            <CustomPDFViewer fileUrl={url} />
          </div>
        </Modal>
      </div>
    );
  };

  return (
    <>
      <Popup
        trigger={
          <Label
            basic
            onClick={() => {
              downloadFileForPreview();
              setOpen(true);
            }}
            className={styles.label}
            as="a"
          >
            <Icon name="file pdf" color="red" />
            {' ' + (fileName.length > 20 ? fileName.substring(0, 20) + '...' : fileName) + ' '}
          </Label>
        }
        on={['hover']}
        size="mini"
        content={fileName}
      />

      <Icon
        link
        name="download"
        color="grey"
        onClick={() => {
          downloadFile();
        }}
      />
      {file && renderDocument(file)}
    </>
  );
}

export default DownloadableFile;
